<template>
  <div>
    <PaymentsTable />
    <Base--SideButtons />
  </div>
</template>

<script>
import PaymentsTable from '../components/common/Table/PaymentsTable/PaymentsTable'

export default {
  components: { PaymentsTable }
}
</script>
